import React from 'react';
import { translate } from 'react-i18next';
import { Card, Input, Checkbox, TextArea, Icon, Button, Dimmer, Dropdown } from 'semantic-ui-react';
import ImageWithClose from 'modules/misc/ImageWithClose.js'
import {colors, buttons, spacings, shadow, fonts} from 'style';


var style = {
    inputWrapper: {
        color: colors.themeDarkerGrey,
        position: 'relative',
        padding: spacings.tiny,
    },
    photoSelector: {
        backgroundColor: colors.themeGrey,
        border: '1px dashed ' + colors.themeDarkerGrey,
        borderRadius: spacings.tiny,
        height: '180px',
        padding: spacings.small,
    },
    dragMessage: {
        padding: spacings.tiny,
        color: colors.themeDarkGrey,
        ...fonts.bodyL,
    },
    preferMessage: {
        padding: spacings.tiny,
        color: colors.themeDarkGrey,
        ...fonts.bodyS,
    },
    photo: {
        height: '200px',
        boxShadow: shadow,
        border: '5px solid white',
    },
    pointsBar: {
        padding: spacings.tiny,
        fontSize: '18px',
        color: colors.pointsYellow,
    },
    pointsIcon: {
        color: colors.pointsYellow,
    },
    uploadPhotoButton: {
        ...buttons.base,
        margin: spacings.tiny,
        backgroundColor: colors.themeBlue,
    },
}

const ChallengeQuestionPhoto = ({t, 
                                 challengeQuestion, 
                                 index, 
                                 highlight, 
                                 onUploadPhoto, 
                                 onDrop, 
                                 onDragOver,
                                 onDragEnter, 
                                 onDragLeave,
                                 onCancelPhoto}) => (
    challengeQuestion.dataType==6 ?
        <div style={style.inputWrapper}>
            {!Boolean(challengeQuestion.data) &&
            <div style={{...style.photoSelector, ...(highlight && {backgroundColor:colors.themeTeal})}} onDrop={onDrop} onDragOver={onDragOver} onDragEnter={onDragEnter} onDragLeave={onDragLeave}>
                {!highlight &&
                <div>
                    <div style={style.dragMessage}>{t('drag-photo-here')}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}</div>
                </div>
                }
                {!highlight &&
                <Button style={style.uploadPhotoButton} 
                        onClick={()=>onUploadPhoto({field:'selectedChallenge.challengeQuestions.' + index + '.data', width:512, height:512})}>
                    {t('upload-photo-button-text')}
                </Button>
                }
                {!highlight &&
                <div style={style.pointsBar}>
                    <Icon style={style.pointsIcon} className="notClickable icon-star"/>
                    {challengeQuestion.points}
                </div>
                }
            </div>
            }
            {Boolean(challengeQuestion.data) &&
                <ImageWithClose style={style.photo}
                                src={challengeQuestion.data}
                                alt=''
                                onClose={() => onCancelPhoto('selectedChallenge.challengeQuestions.' + index + '.data')} />
            }
            
        </div>
    : null
);
export default translate('logs')(ChallengeQuestionPhoto);



// WEBPACK FOOTER //
// ./src/modules/logs/ChallengeQuestionPhoto.js